import { NetworkListPage } from "fleet/view/network/list";
import { connect } from "react-redux";
import { getAuthUser } from "redux-store/auth/selectors";
import { networksSelector } from "redux-store/networks/selectors";
import { makeGetAllAsArray } from "redux-store/selectors";
import { isVenueSyncEnabled } from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";

const getAllNetworksAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const storesLoaded = storesReady(state.global.networks);
  const networksObject = networksSelector(state);
  const networks = getAllNetworksAsArray({ byId: networksObject });
  const user = getAuthUser(state);
  const venueSyncEnabled = isVenueSyncEnabled(user);

  return {
    networks,
    storesLoaded,
    venueSyncEnabled,
  };
}

const ConnectedNetworkListPage = connect(mapStateToProps)(NetworkListPage);

export { ConnectedNetworkListPage };
